import Vue from 'vue'
import enums from '@/common/enums'
const regions = enums.platforms.rbm.regions

Vue.filter('rbmRegion', region => {
  if (region === regions.asiaPacific) return 'Asia Pacific'
  if (region === regions.europe) return 'Europe'
  if (region === regions.northAmerica) return 'North America'

  return region
})
